import { render, staticRenderFns } from "./GemesysOrderReceipt.vue?vue&type=template&id=617633f4&"
import script from "./GemesysOrderReceipt.vue?vue&type=script&lang=js&"
export * from "./GemesysOrderReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports